"use client";

import "./Privacy.scss";
import privacyConfig from "./PrivacyConfig";
import PageBanner from "@/components/PageBanner/PageBanner";
import { Container } from "react-bootstrap";

const Privacy = () => {
  const content = privacyConfig.privacy;

  return (
    <>
      <PageBanner title="Privacy Policy" page="Privacy" />

      <section className="privacy-content-section">
        <Container>
          <div className="privacy-container">
            {content.sections.map((section, i) => (
              <div key={i} className="privacy-section">
                <p className="privacy-intro">{section.introduction}</p>
                <h2 className="privacy-heading">{section.heading}</h2>

                {section.content.map((c, j) => (
                  <div key={j}>
                    {c.subheading && (
                      <h3 className="privacy-subheading">{c.subheading}</h3>
                    )}
                    {c.text && <p className="privacy-text">{c.text}</p>}

                    {c.list && (
                      <ul>
                        {c.list.map((item, k) => (
                          <li key={k}>{item}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
            ))}

            <p className="privacy-conclusion">{content.conclusion}</p>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Privacy;
